import { render, staticRenderFns } from "./order-pay.vue?vue&type=template&id=55ee95bf&scoped=true"
import script from "./order-pay.vue?vue&type=script&lang=js"
export * from "./order-pay.vue?vue&type=script&lang=js"
import style0 from "./order-pay.vue?vue&type=style&index=0&id=55ee95bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee95bf",
  null
  
)

export default component.exports